<template>
    <div class="catalogue-list p-3">
        <div class="header-card d-flex justify-content-between align-items-center mb-4 p-3 rounded shadow-sm">
            <div>
                <h1 v-if="tenant_id">{{ userStore.tenant.name }}</h1>
                <h2 class="mb-1">Liste des catalogues</h2>
                <small class="text-muted">Total : {{ catalogues.length }} catalogues</small>
            </div>
            <div>
                <span class="btn btn-sm" @click="$router.push({ name: 'cart' })">
                    <i class="bi bi-cart fs-5"></i>
                    <sup class="cart-count">
                        <span class="badge bg-danger text-white fs-" v-if="cartStore.cart.length > 0">
                            {{ cartStore.cart.length }}
                        </span>
                    </sup>
                </span>
            </div>
        </div>

        <div class="row mb-4">
            <div class="col-md-6 col-12">
                <input type="text" class="form-control" placeholder="Recherche par label, code ou description"
                    v-model="search" />
            </div>
        </div>

        <div v-if="cataloguesToPrint.length > 0">
            <div class="d-none d-md-block table-responsive">
                <table class="table table-hover table-striped align-middle catalogue-table">
                    <thead class="table-purple text-white">
                        <tr>
                            <th>#</th>
                            <th>Label</th>
                            <th>Code</th>
                            <th>Image</th>
                            <th>Description</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(catalogue, idx) in cataloguesToPrint" :key="catalogue.id" class="table-row-hover">
                            <td>{{ idx + 1 }}</td>
                            <td>{{ catalogue.label || '—' }}</td>
                            <td>{{ catalogue.code || '—' }}</td>
                            <td>
                                <img :src="$api.defaults.assetsBaseURL + catalogue.image_path" alt="Catalogue image"
                                    class="img-fluid rounded catalogue-image cursor-pointer"
                                    @click="openImageModal(catalogue.image_path)" />
                            </td>
                            <td style="white-space: pre-wrap;">{{ catalogue.description || 'Aucune description' }}</td>
                            <td>
                                <div>
                                    <div v-if="!isInCart(catalogue)" class="d-grid gap-2 mt-3">
                                        <button class="btn btn-sm btn-secondary me-1"
                                            @click="addToCart(catalogue)">Ajouter au
                                            panier</button>
                                    </div>
                                    <div v-else class="row mt-3">
                                        <div class="col-12">
                                            <div class="d-flex justify-content-end align-items-center">
                                                <button class="btn btn-sm btn-primary me-1"
                                                    @click="removeFromCart(catalogue)"><i
                                                        class="bi bi-dash"></i></button>
                                                <span class="badge bg-success me-2">Quantité :
                                                    {{cartStore.cart.find(item =>
                                                        item.id === catalogue.id)?.quantity}}</span>
                                                <button class="btn btn-sm btn-primary me-1"
                                                    @click="addToCart(catalogue)"><i class="bi bi-plus"></i></button>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-end align-items-center">
                                            <label for="sizeSelect" class="form-label-sm">Taille</label>
                                            <select class="form-select-sm form-select" aria-label="Taille"
                                                id="sizeSelect" @change="cartStore.save()"
                                                v-model="cartStore.cart.find(item => item.id === catalogue.id).style_body_size">
                                                <option value="S">S</option>
                                                <option value="M">M</option>
                                                <option value="L">L</option>
                                                <option value="XL">XL</option>
                                                <option value="XXL">XXL</option>
                                            </select>
                                        </div>

                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="d-block d-md-none">
                <div class="card mb-2" v-for="catalogue in cataloguesToPrint" :key="catalogue.id">
                    <div class="card-body">
                        <div class="row g-3 align-items-center">
                            <div class="col-5">
                                <img :src="$api.defaults.assetsBaseURL + catalogue.image_path" alt="Catalogue image"
                                    class="img-fluid rounded catalogue-image cursor-pointer"
                                    @click="openImageModal(catalogue.image_path)" />
                            </div>
                            <div class="col-7">
                                <h5 class="mb-1">{{ catalogue.label }}</h5>
                                <p class="mb-1"><strong>Code :</strong> {{ catalogue.code }}</p>
                                <p class="mb-1 text-muted small" style="white-space: pre-wrap;">{{ catalogue.description
                                    }}</p>
                            </div>
                        </div>
                        <div>
                            <div v-if="!isInCart(catalogue)" class="d-grid gap-2 mt-3">
                                <button class="btn btn-sm btn-secondary me-1" @click="addToCart(catalogue)">Ajouter au
                                    panier</button>
                            </div>
                            <div v-else class="row mt-3">
                                <div class="col-8">
                                    <div class="d-flex justify-content-end align-items-center">
                                        <button class="btn btn-sm btn-primary me-1"
                                            @click="removeFromCart(catalogue)"><i class="bi bi-dash"></i></button>
                                        <span class="badge bg-success me-2">Quantité : {{cartStore.cart.find(item =>
                                            item.id === catalogue.id)?.quantity}}</span>
                                        <button class="btn btn-sm btn-primary me-1" @click="addToCart(catalogue)"><i
                                                class="bi bi-plus"></i></button>
                                    </div>
                                </div>
                                <div class="col-4">

                                    <select class="form-select-sm form-select" aria-label="Taille"
                                        @change="cartStore.save()"
                                        v-model="cartStore.cart.find(item => item.id === catalogue.id).style_body_size">
                                        <option value="S">S</option>
                                        <option value="M">M</option>
                                        <option value="L">L</option>
                                        <option value="XL">XL</option>
                                        <option value="XXL">XXL</option>
                                    </select>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- Image Modal -->
    <div v-if="showModal" class="modal fade show d-block" @click="closeImageModal"
        style="background-color: rgba(0,0,0,0.8);">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content border-0 bg-transparent">
                <div class="modal-body text-center p-0">
                    <img :src="$api.defaults.assetsBaseURL + selectedImage" class="img-fluid rounded" @click.stop />
                    <button type="button" class="btn-close btn-close-white position-absolute top-0 end-0 m-3"
                        @click="closeImageModal"></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import { useUserStore } from '@/store/userStore';
import { cartStore } from '@/store/cartStore'

export default {
    name: 'CatalogueList',
    props: {
        tenant_id: {
            type: [String, Number],
            required: false
        }
    },

    data() {
        return {
            search: '',
            catalogues: [],
            link: '/catalogs',
            showModal: false,
            selectedImage: null,
            // cartItems: []
        };
    },
    computed: {
        cataloguesToPrint() {
            const query = this.search.trim().toLowerCase();
            if (query.length < 2) {
                return this.catalogues;
            }
            return this.catalogues.filter(catalogue => {
                return (catalogue.label?.toLowerCase().includes(query) || false)
                    || (catalogue.code?.toLowerCase().includes(query) || false);
                // || (catalogue.description?.toLowerCase().includes(query) || false);
            });
        },
        userStore() {
            return useUserStore();
        },
        cartStore() {
            return cartStore();
        }

    },
    methods: {
        getCatalogues() {
            if (this.tenant_id) {
                this.link = `/catalogs_for_clients/${this.tenant_id}`;
            }
            this.$api.get(this.link)
                .then(res => {
                    this.catalogues = res.data.data || [];
                })
                .catch(err => {
                    console.error("Error fetching catalogues:", err);
                    Swal.fire('Erreur', 'Une erreur est survenue lors du chargement des catalogues.', 'error');
                });
        },
        addToCart(catalogue) {
            const existingItem = this.cartStore.cart.find(item => item.id === catalogue.id);
            if (existingItem) {
                existingItem.quantity += 1;
            } else {
                catalogue.style_body_size = 'M'; // Valeur par défaut, peut être modifiée plus tard
                catalogue.quantity = 1;
                this.cartStore.cart.push(catalogue);
            }
            this.cartStore.save(this.cartStore.cart);
        },
        isInCart(catalogue) {
            return this.cartStore.cart.some(item => item.id === catalogue.id);
        },
        removeFromCart(catalogue) {
            const existingItem = this.cartStore.cart.find(item => item.id === catalogue.id);
            if (existingItem) {
                if (existingItem.quantity > 1) {
                    existingItem.quantity -= 1;
                } else {
                    this.cartStore.cart = this.cartStore.cart.filter(item => item.id !== catalogue.id);
                }
            }
            this.cartStore.save(this.cartStore.cart);

        },
        openImageModal(image) {
            this.selectedImage = image;
            this.showModal = true;
        },
        closeImageModal() {
            this.showModal = false;
            this.selectedImage = null;
        },

    },
    mounted() {
        this.getCatalogues();
        this.cartStore.load()
    }
};
</script>

<style scoped>
.catalogue-list {
    background: linear-gradient(130deg, #f8f2ff 0%, #fff 60%);
}

.header-card {
    background-color: rgba(106, 74, 166, 0.12);
    border: 1px solid rgba(106, 74, 166, 0.3);
}

.table-purple {
    background-color: #6a4aa6;
    border-color: #6a4aa6;
}

.catalogue-table {
    border: 1px solid rgba(106, 74, 166, 0.3);
    box-shadow: 0 6px 18px rgba(106, 74, 166, 0.12);
}

.catalogue-image {
    max-height: 120px;
    object-fit: cover;
    width: 100%;
}

.cursor-pointer {
    cursor: pointer;
}

.mobile-catalogue-card {
    border: 1px solid rgba(106, 74, 166, 0.18);
    border-radius: 12px;
    padding: 1rem;
    background: #ffffff;
    box-shadow: 0 8px 24px rgba(106, 74, 166, 0.08);
}

.mobile-catalogue-card h5 {
    margin-bottom: 0.4rem;
}

.cart-count {
    position: relative;
    top: -15px;
    right: 10px;
    font-size: 0.75rem;
    padding: 0.25em 0.5em;
    border-radius: 50%;
}
</style>
